import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { ImagePlaceholderProps } from './types'
import './ImagePlaceholder.css'

/**
 * Hueco reservado para una foto o un mapa que la propiedad aún no ha dado: superficie hundida con un icono, sin texto de
 * maqueta (fase 4, A16). Conserva el ratio para no mover el layout y se anuncia como imagen con `label`.
 */
export function ImagePlaceholder({ label, icon = 'image', ratio = '16 / 10', className, style, children }: ImagePlaceholderProps) {
  return (
    <div role="img" aria-label={label} className={cx('hp-placeholder', className)} style={{ aspectRatio: ratio, ...style }}>
      {icon && <Icon name={icon} size={32} className="hp-placeholder__icon" />}
      {children}
    </div>
  )
}
